import { ServiceCard } from '@/components/features/ServiceCard';
import { ContactCTA } from '@/components/features/ContactCTA';
import { SERVICES } from '@/lib/constants';

/**
 * Services overview page
 */
export function ServicesOverview() {
  return (
    <>
      {/* Page Header */}
      <section className="section-padding bg-gradient-to-b from-primary/5 to-transparent">
        <div className="container-custom text-center">
          <span className="category-label">Our Services</span>
          <h1 className="text-4xl font-bold md:text-5xl">
            What We Offer
          </h1>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-muted-foreground">
            Professional gardening, cleaning, and taxidermy services in Tasmania.
            Quality craftsmanship with a personal touch.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-padding" aria-labelledby="all-services">
        <div className="container-custom">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {Object.values(SERVICES).map((service) => (
              <ServiceCard
                key={service.id}
                id={service.id}
                title={service.title}
                description={service.description}
                href={service.href}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <ContactCTA />
    </>
  );
}
